import { render, staticRenderFns } from "./DeviceLight.vue?vue&type=template&id=52c418a3&scoped=true&"
import script from "./DeviceLight.vue?vue&type=script&lang=js&"
export * from "./DeviceLight.vue?vue&type=script&lang=js&"
import style0 from "./DeviceLight.vue?vue&type=style&index=0&id=52c418a3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c418a3",
  null
  
)

export default component.exports